exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-dialog{width:90vw!important;height:90vh!important;max-height:100%;max-width:100%}.modal-dialog code.codigos{display:block;height:200px;overflow:scroll;margin:1em}.modal-dialog .acciones{display:flex;margin:1em 0;justify-content:center}#pdftext{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b0c3c09","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ModalExportCenters.vue
// module id = 87
// module chunks = 0